import { useQuery } from '@tanstack/react-query'

import { llmApi } from '@/lib/api'

/** How many audit rows the log asks for. The gateway clamps at 1000 and its
 *  summary describes exactly the rows it returned, so a bigger number here
 *  is a more truthful total — at the cost of a bigger response. 200 covers
 *  a normal template's whole history. */
export const LLM_CALL_LIMIT = 200

/**
 * The template's LLM audit trail.
 *
 * Read by the "Protokoll und Kosten" section *and* by the dialog it opens,
 * under one key, so opening the dialog costs no second request and the
 * headline figure and the table can never disagree.
 *
 * `readMW`, so a viewer may read it; a 403 is information, not an error to
 * retry.
 */
export function useLlmCalls(templateId: string, enabled = true) {
  const query = useQuery({
    queryKey: ['llm', 'calls', templateId, LLM_CALL_LIMIT],
    queryFn: () => llmApi.calls(templateId, { limit: LLM_CALL_LIMIT }),
    enabled: enabled && templateId.length > 0,
    staleTime: 60_000,
    retry: false,
  })
  const forbidden = (query.error as { status?: number } | null)?.status === 403
  return { ...query, forbidden }
}
